import React, { Component } from 'react'
import { makeDefaultFailedContainer } from 'components/container'
import _get from 'lodash/get'
import { Input, Button } from '@driftt/tide-core-legacy'
import LoadingDots from 'components/shared/LoadingDots'
import ConnectLink from '../components/ConnectLink'
import Connected from '../components/Connected'
import { popUp } from 'components/Integration/helpers'
import { APP_URL } from 'constants/ResourcesConstants'
import style from './style.styl'

const ENABLE_BUTTON_SCRIPT_URL = "https://static.segment.com/enable-button/v1/index.js"
const SEGMENT_HELP_URL = "https://help.drift.com/article/segment/"
const WRITEKEY_HELP_URL = "https://segment.com/docs/guides/setup/how-do-i-find-my-write-key/"

class SegmentInstaller extends Component {

  state = {
    writeKey: '',
    updating: false,
    showKey: false
  }

  showKeyInput() {
    this.setState({showKey: true})
  }

  componentDidMount() {
    const segmentScript = document.createElement('script')
    segmentScript.src = ENABLE_BUTTON_SCRIPT_URL
    document.head.appendChild(segmentScript)
  }

  componentWillReceiveProps({ isConnected }) {
    const nextIsConnected = isConnected
    const currentIsConnected = this.props.isConnected
    if (currentIsConnected !== nextIsConnected) {
      this.setState({ updating: false })
      if (nextIsConnected) {
        this.app.actions.NotificationActions.pushNotification({
          content: 'Segment was successfully connected!',
        })
      }
    }
  }

  handleConnect = () => {
    const { writeKey } = this.state
    const segmentButtonRef = document.querySelector('.segment-enable-button a')
    const link = _get(segmentButtonRef, 'href')
    popUp({
      path: link,
      onClose: () => {
        if (this.state.updating) {
          this.app.actions.NotificationActions.pushNotification({ variant: 'red', content: 'We could not connect. Please check your input and try again.' })
          this.setState({ updating: false })
        }
      },
      onMessage: () => {
        this.app.actions.OrgPropertiesActions.updateProperties(this.props.currentUser.orgId, { segmentEnabled: true })
        this.app.queries.IntegrationsQueries.fetchIntegrationStates()
        this.setState({ updating: false })
      }
    })
    if (writeKey) {
      this.app.queries.IntegrationsQueries.createAccessToken('segment', { writeKey })
    }
    this.setState({ updating: true })
  }

  handleDisconnect = () => {
    this.app.actions.OrgPropertiesActions.updateProperties(this.props.currentUser.orgId, { segmentEnabled: false, segmentWriteKey: null })
    this.app.queries.IntegrationsQueries.fetchIntegrationStates()
    this.setState({ updating: true })
  }

  getConnectionPayload = () => {
    const { writeKey } = this.state
    return { writeKey, segmentEnabled: true }
  }

  renderNotConnected = () => {
    const { isOauth } = this.props
    if (isOauth) {
      return this.renderOauthConnector()
    }
    return <ConnectLink handleConnect={this.handleConnect} connectorType="button" buttonType="tertiary"/>
  }

  renderConnected = () => {
    return <Connected integrationId="segment" handleDisconnect={this.handleDisconnect}/>
  }

  renderConnector = () => {
    const { isConnected } = this.props
    if (isConnected) {
      return this.renderConnected()
    } else {
      return this.renderNotConnected()
    }
  }

  renderWriteKeyInput = () => (
    <Input
      placeholder="e.g. 123456"
      label="SEGMENT WRITE KEY (optional)"
      valueLink={{
        requestChange: (input) => {
          this.setState({ writeKey: input.trim() })
        },
        value: this.state.writeKey
      }}
      isValid={true}
    />
  )

  renderHiddenSegmentButton = () => {
    const { embedsByInboxId, apiKey: { accessToken }} = this.props
    const embedId = _.last(_.keys(embedsByInboxId))
    const dataSettings = JSON.stringify({ apiKey: accessToken, embedId })
    return (
      <div
        style={{ display: 'none' }}
        className="segment-enable-button"
        data-integration="drift"
        data-settings={ dataSettings }
        data-redirect-url={ `${APP_URL}/accept-integration/segment` }
      >
      </div>
    )
  }

  render() {
    const { updating, showKey } = this.state
    const { isConnected, apiKey: { accessToken }} = this.props
    return (
      <div>
        {'With Segment you can install Drift on your site with one click, no need to touch any code at all! Just click the button below to connect your account and install the Drift widget.'}
        <br/><br/>
        {'Need some help? Click '}
        <a className={style.Link} href={SEGMENT_HELP_URL}>here</a>
        {' for more details!'}
        <br/>
        { (isConnected && accessToken) && <div>
          <Input
              labelType="strong"
              className='segment-key-input'
              onClick={() => this.showKeyInput()}
              description="Click to reveal. This key is used by Segment to authorize Segment data pushes to Drift."
              type={showKey ? 'text' : 'password'}
              value={accessToken}
              readOnly
            />
        </div>}
        { updating ?
          <div style={{ maxWidth: '50px' }}><LoadingDots /></div> :
          this.renderConnector()
        }
        <br/>
        {"OPTIONAL: If you want your chat data to go back to Segment, enter your write key below. If you've already installed Drift without the "}
        <a className={style.Link} href={WRITEKEY_HELP_URL}>write key</a>
        {", you'll need to disconnect and re-connect to enter it in now."}
        <br/> <br/>
        { isConnected ? null : this.renderWriteKeyInput() }
        {this.renderHiddenSegmentButton()}
      </div>
    )
  }
}

export const SegmentInstallerContainer = makeDefaultFailedContainer(SegmentInstaller, {
  listenTo: ['stores.UserStore', 'stores.OrgPropertiesStore', 'stores.ApiKeyStore', 'stores.EmbedStore'],
  fetch: {
    currentUser() {
      return this.app.stores.UserStore.getOrFetchCurrentUser()
    },
    apiKey() {
      return this.app.stores.ApiKeyStore.getApiKeyForCurrentOrg()
    },
    embedsByInboxId() {
      return this.app.stores.EmbedStore.getOrFetchEmbedList()
    },
    orgProperties() {
      return this.app.stores.OrgPropertiesStore.fetchPropertiesForCurrentOrg()
    }
  }
})

export default SegmentInstallerContainer



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/SegmentInstaller.js